// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NumberCounter_wrapper__8hir9","label":"NumberCounter_label__AGZL_"};